import {get, post} from '@/utils/request'
import apiMap from "@/config";

const riskApi = apiMap.riskApi

// 获取用户权限
export const getUserLimits = data => get(`${riskApi}/privilege/query/user/web/info`, data)
